<mat-form-field
  (keyup.enter)="$event.stopPropagation(); enter.emit()"
  [matTooltip]="'we_search.tooltip' | translate"
>
  <mat-label>{{ 'we_search.label' | translate }}</mat-label>
  <!--Select section-->
  <mtx-select
    *ngIf="isSelect"
    appendTo="body"
    [items]="(weList$ | async) ?? []"
    [typeahead]="weListTypeahead$"
    [loading]="weListLoading"
    [virtualScroll]="false"
    [minTermLength]="3"
    [typeToSearchText]="this.translateService.stream('formErrors.min_char', { chars: 3 }) | async"
    [notFoundText]="'we_search.no_items' | translate"
    (change)="onChange($event)"
    [clearable]="false"
    [disabled]="disabled"
    [(ngModel)]="selectedWe"
  >
    <ng-template ng-label-tmp let-item="item">
      <span>
        {{ item.normalizedNumber }} | {{ item.city }} {{ item.postcode }} {{ item.street }} |
        {{ item.dfmgId }} | {{ item.tmdId }}
      </span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <span>
        {{ item.normalizedNumber }} | {{ item.city }} {{ item.postcode }} {{ item.street }} |
        {{ item.dfmgId }} | {{ item.tmdId }}
      </span>
    </ng-template>
  </mtx-select>
  <!--Input section-->
  <input
    *ngIf="!isSelect"
    matInput
    type="text"
    [formControl]="weSearchFormControl"
    [disableControl]="disabled"
  />
  <span matSuffix *ngIf="!isSelect && weListLoading">
    <mat-spinner [diameter]="40"></mat-spinner
  ></span>
</mat-form-field>
